import React from "react";
import { Container, Row, Col } from "react-grid-system";

// STYLES
import styled from "styled-components";

// SHARED
import { Section } from "../../shared/shared";

// COMPONENTS

export default class WorkshopsText extends React.PureComponent {
  render() {
    let { t } = this.props;
    return (
      <Section>
        <Container>
          <Row>
            <Col sm={12} className="center">
                <WorkshopsTextText>{t('WorkshopText1')}</WorkshopsTextText>
                <WorkshopsTextText>{t('WorkshopText2')}</WorkshopsTextText>
                <WorkshopsTextText>{t('WorkshopText3')}</WorkshopsTextText>
                <WorkshopsTextText>{t('WorkshopText4')}</WorkshopsTextText>
            </Col>
          </Row>
        </Container>
        <Space></Space>
        <Container>
          <Row>
            <Col sm={12} className="center">
                <YoutubeIframe width="560" height="315" src="https://www.youtube.com/embed/uAfslxhFojE?si=Utuy42fw43m7Vm5F" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></YoutubeIframe>
            </Col>
          </Row>
        </Container>
        <Space></Space>
        <Container>
          <Row>
            <Col sm={12} className="center">
                <YoutubeIframe width="560" height="315" src="https://www.youtube.com/embed/5RNK2GWH4YM?si=VvUomH1wwusx_LVh" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></YoutubeIframe>
            </Col>
          </Row>
        </Container>
        <Space></Space>
        <Container>
          <Row>
            <Col sm={12} className="center">
                <YoutubeIframe width="560" height="315" src="https://www.youtube.com/embed/AgttlVCrvpg?si=ZxPZoWiwQyW88lKO" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></YoutubeIframe>
            </Col>
          </Row>
        </Container>

        
      </Section>
    );
  }
}

const YoutubeIframe = styled.iframe `
  @media screen and (max-width: 600px){
    width:100%;
  }
`

const WorkshopsTextText = styled.p`
  max-width: 860px;
  opacity: 0.8;
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  margin-right: auto;
  margin-left: auto;
  margin-top: 35px;

  @media screen and (max-width: 767px) {
    text-align: center;
  }
`;
const Space = styled.div`
  width: 100%;
  height: 120px;

  @media screen and (max-width: 992px) {
    display: none;
  }
`;


// WEBPACK FOOTER //
// ./src/components/workshopsText/workshopsText.component.js